module.exports = __webpack_public_path__ + "img/home_logo.6b23f986.png";